import type { TourStepDef } from "./tourSteps";

export const MOBILE_TOUR_STEPS: TourStepDef[] = [
  {
    target: null,
    title: "Welcome to mobile!",
    description: "Let's take a quick tour of your mobile dashboard.",
  },
  {
    target: "mobile-tab-home",
    title: "Home",
    description: "Your dashboard overview with attendance, ratios, and action items at a glance.",
  },
  {
    target: "mobile-tab-students",
    title: "Students",
    description: "View your student roster, take attendance, and manage classrooms.",
  },
  {
    target: "mobile-tab-messages",
    title: "Messages",
    description: "Send and receive messages with parents and staff.",
  },
  {
    target: "mobile-tab-more",
    title: "More",
    description: "Access Billing, Leads, Reports, Settings, and everything else from here.",
  },
  {
    target: "mobile-search",
    title: "Search",
    description: "Find any child, family, or staff member instantly.",
  },
  {
    target: null,
    title: "You're all set!",
    description: "Your mobile dashboard is ready. Tap any tab to dive in.",
  },
];
